import React from 'react';

import { Container, Icon, Title, Description, ActionSlot } from './styles';

interface EmptyStateProps {
  title: string;
  description?: string;
  /** Ícone opcional (ex.: `FiInbox`). */
  icon?: React.ReactNode;
  /** Ação opcional (ex.: botão "Criar curso"). */
  action?: React.ReactNode;
}

/**
 * Estado vazio do admin. Ensina o que fazer (CTA), em vez de apenas dizer
 * "nada aqui".
 */
const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  action,
}) => {
  return (
    <Container>
      {icon && <Icon>{icon}</Icon>}
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
      {action && <ActionSlot>{action}</ActionSlot>}
    </Container>
  );
};

export default EmptyState;
